import api from "./api";

// ---------- Temas de evaluacion ----------

export const getsTemaEvaluacionView = async () => {
    const response = await api.get("/Evaluacion/GetsTemaEvaluacionView");

    return response.data.data;
}

export const getsTemaEvaluacionPadreView = async () => {
    const response = await api.get("/Evaluacion/GetsTemaEvaluacionPadreView");

    return response.data.data;
}

export const addUpdateTemaEvaluacion = (dataPost) =>
    api.post("/Evaluacion/AddUpdateTemaEvaluacion", dataPost);

export const deleteTemaEvaluacion = (idTemaEvaluacion) =>
    api.post("/Evaluacion/DeleteTemaEvaluacion?idTemaEvaluacion=" + idTemaEvaluacion);

// ---------- Evaluaciones ----------

export const getsEvaluacionView = async (idParticipante) => {
    const response = await api.get("/Evaluacion/GetsEvaluacionView?idParticipante=" + idParticipante);

    return response.data.data;
}

export const addUpdateEvaluacion = (dataPost) =>
    api.post("/Evaluacion/AddUpdateEvaluacion", dataPost);

export const deleteEvaluacion = (idEvaluacion) =>
    api.post("/Evaluacion/DeleteEvaluacion?idEvaluacion=" + idEvaluacion);

// ---------- Detalle de la evaluacion ----------

export const getsEvaluacionDetalleView = async (idEvaluacion) => {
    const response = await api.get("/Evaluacion/GetsEvaluacionDetalleView?idEvaluacion=" + idEvaluacion);

    return response.data.data;
}

// ---------- Catalogo de objetivos ----------

export const getsObjetivoCatalogoView = async (idTemaEvaluacion) => {
    const response = await api.get("/Evaluacion/GetsObjetivoCatalogoView?idTemaEvaluacion=" + idTemaEvaluacion);

    return response.data.data;
}

// Busqueda del autocompletado de objetivos del plan de terapia.
export const buscarObjetivoCatalogo = async (texto) => {
    const response = await api.get("/Evaluacion/BuscarObjetivoCatalogo?texto=" + encodeURIComponent(texto || ""));

    return response.data.data;
}

export const addUpdateObjetivoCatalogo = (dataPost) =>
    api.post("/Evaluacion/AddUpdateObjetivoCatalogo", dataPost);

export const deleteObjetivoCatalogo = (idObjetivoCatalogo) =>
    api.post("/Evaluacion/DeleteObjetivoCatalogo?idObjetivoCatalogo=" + idObjetivoCatalogo);

// ---------- Objetivos de un participante ----------

export const getsParticipanteObjetivoView = async (idParticipante) => {
    const response = await api.get("/Evaluacion/GetsParticipanteObjetivoView?idParticipante=" + idParticipante);

    return response.data.data;
}

export const addUpdateParticipanteObjetivo = (dataPost) =>
    api.post("/Evaluacion/AddUpdateParticipanteObjetivo", dataPost);

export const deleteParticipanteObjetivo = (idParticipanteObjetivo) =>
    api.post("/Evaluacion/DeleteParticipanteObjetivo?idParticipanteObjetivo=" + idParticipanteObjetivo);

export const annulParticipanteObjetivo = (idParticipanteObjetivo) =>
    api.post("/Evaluacion/AnnulParticipanteObjetivo?idParticipanteObjetivo=" + idParticipanteObjetivo);

export const activeParticipanteObjetivo = (idParticipanteObjetivo) =>
    api.post("/Evaluacion/ActiveParticipanteObjetivo?idParticipanteObjetivo=" + idParticipanteObjetivo);

export const annulEvaluacion = (idEvaluacion) =>
    api.post("/Evaluacion/AnnulEvaluacion?idEvaluacion=" + idEvaluacion);

export const activeEvaluacion = (idEvaluacion) =>
    api.post("/Evaluacion/ActiveEvaluacion?idEvaluacion=" + idEvaluacion);
